import { memo } from "react"

import { BaseTopBar } from "../TopBars/BaseTopBar"

export const ProjectFormsViewTopBar = memo(() => {
	return <BaseTopBar showAIButton={false} />
})
ProjectFormsViewTopBar.displayName = "ProjectFormsViewTopBar"
